<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row :gutter="10" class="text-left">
      <el-col :span="6">
        <el-select v-model="type" style="width:100%" @change="getTemplateList">
          <el-option v-for="(item,index) in typeList" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6" v-if="type!==''">
        <el-select v-model="templateId" style="width:100%" @change="getTemplateInfo">
          <el-option v-for="(item,index) in templateList" :key="index" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-button @click="addItem()" v-if="info.id !== ''">添加考核项</el-button>
    <div>
      <el-form :label-width="formLabelWidth">
        <el-form-item label="员工岗位" required>
          <el-select v-model="info.type" style="width:100%">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input v-model="info.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="提示信息">
          <el-input v-model="info.notice" type="textarea" placeholder="请输入提示信息"
                    :autosize="{ minRows: 2}"></el-input>
        </el-form-item>
        <el-form-item label="考核项" v-if="info.id !== ''">
          <el-table :data="detail" border default-expand-all row-key="id">
            <el-table-column prop="title" label="考核内容"></el-table-column>
            <el-table-column prop="score" label="分值"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button v-if="scope.row.pid===0" type="success" @click="addItem(scope.row.id)">添加考核内容
                </el-button>
                <el-button type="primary" @click="mdfyItem(scope.row)">修改</el-button>
                <el-button type="danger">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="info.id !== ''">总分:{{ totalScore }}</div>
    <div>
      <el-button @click="submitInfo">保存</el-button>
    </div>
    <el-dialog :visible.sync="addDiv" :show-close="false" :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <el-form-item label="归属">
          <el-select v-model="itemInfo.pid" style="width:100%">
            <el-option :value="0" label="顶级"></el-option>
            <el-option v-for="(level,levelIndex) in detail" :key="levelIndex" :label="level.title"
                       :value="level.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考核内容">
          <el-input v-model="itemInfo.title" type="textarea" :autosize="{ minRows: 2}"></el-input>
        </el-form-item>
        <el-form-item label="分值">
          <el-input v-model="itemInfo.score" placeholder="考核项总分值，如果有子考核项，请留空">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="itemInfo.sort" placeholder="考核内容排序，数值越大越靠前"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submit" size='mini'>提交</el-button>
        <el-button @click="closeAddDiv" size='mini'>返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      info: {
        id: '',
        type: '',
        title: ''
      },
      detail: [],
      type: '',
      typeList: [],
      templateId: '',
      templateList: [],
      tempInfo: {},
      addDiv: false,
      itemInfo: {
        id: '',
        pid: 0,
        score: '',
        sort: '',
        status: 1,
        title: '',
      }
    }
  },
  computed: {
    totalScore() {
      let total = 0;
      for (let item of this.detail) {
        if (item.children) {
          for (let i of item.children) {
            total += Number(i.score)
          }
        }
        if (!isNaN(item.score)) {
          total += Number(item.score);
        }
      }
      return total;
    }
  },
  methods: {
    getTemplateInfo() {
      this.info = {};
      this.$axios({
        url: this.HOST + '/kaohe/template/getExcellentTemplateInfo',
        method: 'post',
        data: {
          id: this.templateId
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.info = res.data.info;
          this.detail = res.data.detail;
          console.log(this.info)
        }
      })
    },
    getTemplateList() {
      this.templateList = [];
      this.templateId = '';
      this.$axios({
        url: this.HOST + '/kaohe/template/getExcellentTemplateList',
        method: 'post',
        data: {
          type: this.type,
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.templateList = res.data.list;
        }
      })
    },
    submitInfo() {
      this.$axios({
        url: this.HOST + '/kaohe/template/saveExcellentTemplate',
        method: 'post',
        data: {
          info: this.info
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type:'success',
            message:res.data.info
          })
          this.info.id = Number(res.data.id);
          this.type = this.info.type;
          this.templateId = this.info.id;
        }
      })
    },
    addItem(pid = 0) {
      this.itemInfo.pid = pid
      this.addDiv = true;
    },
    closeAddDiv() {
      this.itemInfo = JSON.parse(JSON.stringify(this.tempInfo));
      this.addDiv = false;
    },
    reset() {
      this.info = {
        id: '',
        type: '',
        title: '',
      };
      this.detail = [];
    },
    submit() {
      this.itemInfo.tid = this.info.id;
      this.$axios({
        url: this.HOST + '/kaohe/template/saveExcellentItem',
        method: 'post',
        data: {
          info: this.itemInfo
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.closeAddDiv();
          this.getTemplateInfo();
        }
      })
    },
    mdfyItem(info) {
      for (let item in this.itemInfo) {
        this.itemInfo[item] = info[item];
      }
      this.addDiv = true;
    }
  },
  mounted() {
    this.tempInfo = JSON.parse(JSON.stringify(this.itemInfo));
    this.$axios({
      url: this.HOST + '/kaohe/index/getCommonInfo',
      method: 'post',
      data: {
        info: ['employeeType'],
      }
    }).then((res) => {
      if (res.data.status === 1) {
        this.typeList = res.data.employeeType;
      }
    })
  }
}
</script>
<style>
.excellent-template-item {
  display: grid;
  grid-template-columns:1fr 1fr;
  grid-gap: 10px;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
}

.excellent-template-item > .el-form-item {
}
</style>